import React, { useEffect, useContext } from "react";
import DriverHeader from "../../components/Drivers/general/DriverHeader";
import DriverBottomnav from "../../components/Drivers/general/DriverBottomnav";
import AppContext from "../../context/AppContext";

const DriverMasterLayout = ({ children, screenName, centered = true, showHeader = true }) => {
  const { setAuthToken } = useContext(AppContext);

  useEffect(() => {
    const authToken = localStorage.getItem("authToken");
    setAuthToken(authToken);
  }, []);

  return (
    <>
      {showHeader && <DriverHeader screenName={screenName} centered={centered} />}
      {children}
      <DriverBottomnav />
    </>
  );
};

export default DriverMasterLayout;